import { IMarketplaceCartItem } from './cart'
import { IBillingDetails, IShippingDetails } from './checkout2'
import { MarketplaceCoupon } from '@scentregroup/shared/types'
import { CreditCard } from '@scentregroup/shared/types'

export interface IPaymentIntent {
  id: string
  clientSecret: string
  paymentMethodId: string
  cardType?: CreditCard
  expYear?: number
  expMonth?: number
  last4?: string
}

export enum MarketplaceFulfilmentType {
  CLICK_AND_COLLECT = 'CLICK_AND_COLLECT',
  DELIVERY = 'DELIVERY',
}

type IBillingAddress = IBillingDetails

export interface IMarketplaceCheckout {
  id: string
  preferredFulfilmentType: MarketplaceFulfilmentType
  fulfilmentPreferences: IMarketplaceFulfilmentPreferences
  fulfilmentOptions: IMarketplaceFulfilmentOption[]
  parcels: IMarketplaceParcel[]
  billingAddress?: IBillingAddress
  currency: string
  total: number
  payment: IPaymentIntent
  shippingAddress?: IShippingDetails
  coupons: MarketplaceCoupon[]
}

export interface IMarketplaceFulfilmentPreferences {
  delivery?: {
    suburb: {
      name: string
      postcode: string
    }
  }
  pickup?: {
    centre: {
      slug: string
      title: string
      physicalAddress: string
      suburb: string
      postcode: string
      state: string
    }
  }
}

export interface IMarketplaceCheckoutVariables {
  id: string
  preferredFulfilmentType?: MarketplaceFulfilmentType
  deliveryLocation?: IMarketplaceDeliveryLocation
  pickupCentreSlug?: string
}

export interface IUpdateMarketplaceCheckoutFulfilmentInput {
  cartId: string
  preferredFulfilmentType: MarketplaceFulfilmentType
  deliveryLocation?: IMarketplaceDeliveryLocation
  pickupCentreSlug?: string
}

export interface IMarketplaceDeliveryLocation {
  postcode: string
  suburb: string
}

export interface IMarketplaceParcel {
  id: string
  fulfilmentType: MarketplaceFulfilmentType
  items: IMarketplaceCartItem[]
  availableFulfilmentOptions: IMarketplaceParcelFulfilmentOption[]
  selectedFulfilmentOption?: IMarketplaceParcelFulfilmentOption | null
}

export interface IMarketplaceParcelFulfilmentOption {
  id: string
  type: MarketplaceFulfilmentType
  cost: number
  provider: string
  fulfilmentDayRange: {
    min: number
    max: number
  }
  label: string
}

export interface IWestFieldDirectStoreInfo {
  title: string
  physicalAddress?: string
  landmarkDescription?: string
  mapIdentifier?: string
  storeFrontImage?: {
    url: string
  }
}

export interface IMarketplaceFulfilmentOption {
  fulfilmentType: MarketplaceFulfilmentType
  cost: number
  fulfilmentDayRange: {
    min: number
    max: number
  }
  label: string
}

export interface IClickAndCollectData {
  cfStoreCollection: { items: IWestFieldDirectStoreInfo[] }
}
